// extracted by mini-css-extract-plugin
export var borderbottom = "RehomingCentreKeyDetails-module--borderbottom--dea64";
export var bordersection = "RehomingCentreKeyDetails-module--bordersection--5ffb3";
export var centreaddress = "RehomingCentreKeyDetails-module--centreaddress--5ec2f";
export var contenttext = "RehomingCentreKeyDetails-module--contenttext--03b5d";
export var contenttitle = "RehomingCentreKeyDetails-module--contenttitle--e950b";
export var details = "RehomingCentreKeyDetails-module--details--a4bcb";
export var detailssection = "RehomingCentreKeyDetails-module--detailssection--129ff";
export var detailssectionitem = "RehomingCentreKeyDetails-module--detailssectionitem--c84d2";
export var followus = "RehomingCentreKeyDetails-module--followus--777ad";
export var itemtitle = "RehomingCentreKeyDetails-module--itemtitle--ad9e0";
export var rehomingcentredetailscolumninner = "RehomingCentreKeyDetails-module--rehomingcentredetailscolumninner--f47f5";
export var showmorebutton = "RehomingCentreKeyDetails-module--showmorebutton--14a92";
export var socmedicons = "RehomingCentreKeyDetails-module--socmedicons--efbff";
export var title = "RehomingCentreKeyDetails-module--title--d3862";
export var titlewrapper = "RehomingCentreKeyDetails-module--titlewrapper--71d5f";